import { DEFAULT_PLACEHOLDER, NULLDATE } from '@constants/generic';
import { PaidOnDetails, SettlementDetails } from '@types';
import { formatISODate } from '@utils/date';

import PaidOnDetailsTooltip from '../components/paidon-details/PaidOnDetails';
import SettlementDetailsTooltip from '../components/settlement-details/SettlementDetails';

export const getSettledOn = (
  id: string,
  status: string,
  settlementStatus: string,
  payment_mode: string,
  settledOn: string,
  settlementDetails?: SettlementDetails[]
) => {
  const hasSettledOn = settlementDetails?.some(
    (detail) => detail.settled_at && detail.settled_at !== NULLDATE
  );

  if (settlementDetails && settlementDetails.length > 0) {
    if (hasSettledOn) {
      if (settlementDetails.length === 1) {
        return formatISODate({
          date: settlementDetails[0].settled_at,
          format: 'dd-mm-yyyy'
        });
      }
      return (
        <SettlementDetailsTooltip
          id={id}
          settlementDetails={settlementDetails}
        />
      );
    }
    return <div className="text-grey">Processing</div>;
  }

  if (payment_mode === 'manual') return DEFAULT_PLACEHOLDER;
  if (status === 'success' && settlementStatus === '')
    return <div className="text-grey">Processing</div>;
  if (status === 'success' && settlementStatus === 'settled')
    return formatISODate({ date: settledOn, format: 'dd-mm-yyyy' });

  return DEFAULT_PLACEHOLDER;
};

export const getPaidOn = (
  id: string,
  paidAt: string,
  totalPaidAmount: string,
  paidOnDetails?: PaidOnDetails[]
) => {
  if (Number(totalPaidAmount) === 0) return DEFAULT_PLACEHOLDER;

  const hasPaidOn = paidOnDetails?.some(
    (detail) => detail.paid_at && detail.paid_at !== NULLDATE
  );

  if (paidOnDetails && paidOnDetails.length > 0) {
    if (hasPaidOn) {
      if (paidOnDetails.length === 1) {
        return formatISODate({
          date: paidOnDetails[0].paid_at,
          format: 'dd-mm-yyyy'
        });
      }
      return <PaidOnDetailsTooltip id={id} paidOnDetails={paidOnDetails} />;
    }
    return DEFAULT_PLACEHOLDER;
  }

  if (paidAt) return formatISODate({ date: paidAt, format: 'dd-mm-yyyy' });

  return DEFAULT_PLACEHOLDER;
};
